import { Box, styled, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { primary } from "../../../constants/theme";
import { sendAnalytics } from "../../../utils/analyticsCommon";

const CustomVehiclePrice = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "16px",
  marginTop: "48px",
  paddingTop: "12px",
  ".content-container": {
    width: "84%",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    ".content-heading": {
      fontSize: "50px",
      fontWeight: "600",
      marginBottom: "10px",
    },
    ".content-subheading": {
      fontSize: "30px",
      color: primary.greyText,
      fontWeight: "600",
      marginBottom: "20px",
    },
    ".content-text": {
      fontSize: "16px",
      marginBottom: "10px",
      fontWeight: "400",
      color: primary.black,
    },
    ".content-text.readmoreText": {
      maxHeight: "70px",
      overflow: "hidden",
    },
    ".content-text.readmoreText.expanded": {
      maxHeight: "none",
    },
    ".listItem": {
      fontSize: "16px",
      fontWeight: "400",
      color: primary.black,
      listStyle: "circle",
    },
    ".list-head": {
      fontWeight: "600",
    },
    ".content-heading2": {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "10px",
    },
    ".content-subheading2": {
      fontSize: "20px",
      fontWeight: "600",
      color: primary.greyText,
      marginBottom: "20px",
    },
  },
  ".pricing-table": {
    textAlign: "left",
    padding: "8px",
    margin: "auto",
    width: "83%",
  },
  ".readmore-btn": {
    background: primary.white,
    boxShadow: "none",
    border: `2px solid ${primary.main}`,
    borderRadius: "5px",
    padding: "12px",
    marginRight: "20px",
    fontSize: "12px",
    color: primary.main,
    marginBottom: "20px",
  },

  [theme.breakpoints.down("md")]: {
    ".content-container": {
      width: "100%",
      padding: "0 15px",
      ".content-heading": {
        fontSize: "30px",
      },
      ".content-subheading": {
        fontSize: "20px",
      },
      ".content-text": {
        fontSize: "16px",
      },
      ".content-heading2": {
        fontSize: "24px",
      },
      ".content-subheading2": {
        fontSize: "20px",
      },
    },
  },

  [theme.breakpoints.down("sm")]: {
    padding: "4px",
    ".content-container": {
      width: "100%",
      padding: "0 15px",
      ".content-heading": {
        fontSize: "24px",
        marginBottom: "10px",
      },
      ".content-subheading": {
        fontSize: "16px",
        marginBottom: "20px",
      },
      ".content-text": {
        fontSize: "12px",
      },
      ".content-subheading2": {
        fontSize: "16px",
        marginBottom: "20px",
      },
    },
    ".pricing-table": {
      textAlign: "left",
      padding: "8px",
      margin: "auto",
      width: "100%",
    },
  },
}));
const VehiclePriceList = ({ priceData, tableHeader = [] }) => {
  const targetRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        sendAnalytics(`vehicle_price_data`, {}, "en");
      }
    }, options);

    if (targetRef.current) observer.observe(targetRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetRef]);
  return (
    <CustomVehiclePrice>
      <Box
        className="content-container"
        id="vehicle-price-data"
        ref={targetRef}
      >
        <Typography variant="h2" className="content-heading2">
          {priceData?.headerInfo}
        </Typography>
        <Typography variant="p" className="content-text">
          {priceData?.description ??
            `At Turno we provide you with the best prices on electric commercial
          vehicles. We are committed to providing affordable financing options
          for goods electric vehicles to individuals as well as small and
          mid-sized businesses. With a team of EV experts, Turno leads the
          industry of electric goods auto in India.`}
        </Typography>
      </Box>
      {/* Pricing table */}
      <table className="pricing-table">
        <tr
          style={{
            border: `1px solid ${primary.greyText}`,
            textAlign: "left",
            padding: "8px",
          }}
        >
          <th
            style={{
              border: `1px solid ${primary.greyText}`,
              textAlign: "left",
              padding: "8px",
            }}
          >
            {tableHeader?.length > 0 ? tableHeader?.[0] : "EV Models"}
          </th>
          <th
            style={{
              border: `1px solid ${primary.greyText}`,
              textAlign: "left",
              padding: "8px",
            }}
          >
            {tableHeader?.length > 0 ? tableHeader?.[1] : "Vehicles Prices"}
          </th>
        </tr>
        {priceData?.priceList?.map((data, index) => (
          <tr
            key={index}
            style={{
              border: `1px solid ${primary.greyText}`,
              textAlign: "left",
              padding: "8px",
            }}
          >
            <td
              style={{
                border: `1px solid ${primary.greyText}`,
                textAlign: "left",
                padding: "8px",
              }}
            >
              {data?.model}
            </td>
            <td
              style={{
                border: `1px solid ${primary.greyText}`,
                textAlign: "left",
                padding: "8px",
              }}
            >
              {data?.prices}
            </td>
          </tr>
        ))}
      </table>
    </CustomVehiclePrice>
  );
};

const MemoizedVehiclePriceList = React.memo(VehiclePriceList);
export default MemoizedVehiclePriceList;
